import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {TerceroUPPasarela} from '../_models/tercero-up-pasarela';

@Injectable({
  providedIn: 'root'
})
export class TerceroUpPasarelaService {
  private rutServicio = AppSettings.rutServiciosTER + '/api/tercerosUPPasarelas';

  constructor(private httClient: HttpClient) {
  }

  listadoHabilitados() {
    return this.httClient.get(`${this.rutServicio}/enabled`).pipe(map(res => res as TerceroUPPasarela[]));
  }

  /**
   * Obtiene la pasarela de un tercero por su identificador.
   *
   * @param idTerceroUPPasarela Identificador de la pasarela.
   * @returns Registro de la pasarela con el tercero y la solicitud asociados.
   */
  obtener(idTerceroUPPasarela: string) {
    return this.httClient.get(`${this.rutServicio}/${idTerceroUPPasarela}`).pipe(map(res => res as TerceroUPPasarela));
  }
}
